import axios from 'axios';

// URL for Google Apps Script Webhook
// The user will need to provide this URL. 
// For now, we use a placeholder or local storage for debugging if needed.
const REPORTING_URL = 'https://script.google.com/macros/s/AKfycbwDbZNDqZbixhIF6NLS4HsDEFyMTUlEDElHnwDsGLKIXcpjur6IY853bJSMG-l9tklm/exec'; 

/**
 * Reports a track like/dislike to the configured webhook.
 * @param {Object} data - Metadata about the track and the action.
 * @param {string} data.artist - Artist name.
 * @param {string} data.track - Track name.
 * @param {string} data.stream - Stream ID (e.g., 'myata').
 * @param {string} data.type - Action type ('like' or 'dislike').
 * @param {string} [data.deviceId] - Optional device identifier.
 */
export const reportTrackFeedback = async (data) => {
    if (!REPORTING_URL) {
        console.warn('[Reporting] No REPORTING_URL configured. Feedback not sent:', data);
        return;
    }

    try {
        // Simplify User Agent
        let device = 'Unknown Device';
        const ua = navigator.userAgent;
        if (/android/i.test(ua)) device = 'Android';
        else if (/iPhone|iPad|iPod/i.test(ua)) device = 'iOS';
        else if (/Windows/i.test(ua)) device = 'Windows';
        else if (/Macintosh/i.test(ua)) device = 'Mac';

        const payload = {
            ...data,
            v: '1.0.2', // Updated version for the new build
            timestamp: new Date().toLocaleString('ru-RU'),
            userAgent: device + ' (' + (ua.includes('(') ? ua.split('(')[1].split(')')[0] : 'Generic') + ')'
        };

        await axios.post(REPORTING_URL, JSON.stringify(payload), {
            headers: {
                'Content-Type': 'text/plain'
            }
        });
        console.log('[Reporting] Feedback sent successfully');
    } catch (error) {
        console.error('[Reporting] Error sending feedback:', error);
    }
};
